module.exports = __webpack_public_path__ + "static/media/dana.27a3ff82.jpeg";